var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudCheckDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 8.38536C24.8933 3.78536 20.8533 0.332031 16 0.332031C12.1467 0.332031 8.8 2.5187 7.13333 5.7187C3.12 6.14536 0 9.54536 0 13.6654C0 18.0787 3.58667 21.6654 8 21.6654H25.3333C29.0133 21.6654 32 18.6787 32 14.9987C32 11.4787 29.2667 8.62536 25.8 8.38536ZM25.3333 18.9987H8C5.05333 18.9987 2.66667 16.612 2.66667 13.6654C2.66667 10.932 4.70667 8.65203 7.41333 8.37203L8.84 8.22536L9.50667 6.9587C10.7733 4.5187 13.2533 2.9987 16 2.9987C19.4933 2.9987 22.5067 5.4787 23.1867 8.90536L23.5867 10.9054L25.6267 11.052C27.7067 11.1854 29.3333 12.932 29.3333 14.9987C29.3333 17.1987 27.5333 18.9987 25.3333 18.9987ZM13.3333 13.9054L10.5467 11.1187L8.66667 12.9987L13.3333 17.6654L21.3467 9.65203L19.4667 7.77203L13.3333 13.9054Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCheckDarkIcon);
export default __webpack_public_path__ + "static/media/CloudCheckDarkIcon.c8b656f3.svg";
export { ForwardRef as ReactComponent };